import type { Field, Section } from '@common/formEngine/formEngine.types';
import type { IPatientContactDetails } from '@common/interfaces/patientContactDetails';
import { pdfExtensions } from '@common/utils/fileExtensions';
import { getProcessActivityAssetsSchema, type ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { HolterExaminationRequest } from './hollterRequestsSchemas';
import type { HolterExaminationRequestBase, HolterReferralAssetsData, HolterReferralData } from './utils/utils';
import { type PatientAlternativeAddressType } from '../../patientContactDetailsSchema';
import {
    holterAnamnesisSection,
    holterHistorySection,
    holterRustEcgSection,
    medicationSection,
} from './hollterRequestsSchemas';
import {
    holterSetupSection,
    patientAddressSection,
    referralSectionBaseFields,
} from './holterExaminationRequestSchemas';

export type HolterZorgDomeinExaminationRequestData = {
    assets: ProcessActivityAsset[];
    patient: IPatientContactDetails;
} & PatientAlternativeAddressType &
    HolterReferralData &
    HolterExaminationRequestBase;

const referralSectionAssetsFields: Array<Field<HolterReferralAssetsData>> = [
    {
        acceptExtensions: pdfExtensions,
        draftSchema: getProcessActivityAssetsSchema({ max: 1 }),
        finalSchema: getProcessActivityAssetsSchema({ max: 1, min: 1 }),
        isRequired: true,
        key: 'assets',
        label: 'Verwijsbrief',
        type: 'assets',
    },
];
export const referralSectionWithAssets: Section<
    HolterReferralData & HolterReferralAssetsData,
    undefined,
    HolterExaminationRequest
> = {
    fields: [...referralSectionBaseFields, ...referralSectionAssetsFields],
    title: 'Verwijzing',
};

export const holterZorgdomeinExaminationRequestSections: Section<
    HolterZorgDomeinExaminationRequestData,
    undefined,
    HolterExaminationRequest
>[] = [
    referralSectionWithAssets,
    holterSetupSection,
    holterAnamnesisSection,
    holterRustEcgSection,
    holterHistorySection,
    medicationSection,
    patientAddressSection,
];
